export default __webpack_public_path__ + "static/media/G0840.Mental_Health-02_(1).1683621780000.c7f006f3.jpg";